import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import React, { useRef, useEffect, useState } from 'react';
import './teams.css';

const teamsData = [
  {
    id: 1,
    image: require('../../assets/Doc_01.jpg'),
    name: 'LUIS MARQUES',
    designation: 'DOCENTE LINGUSITICO',
  },
  {
    id: 2,
    image: require('../../assets/Doc_02.jpg'),
    name: 'LUVAMBO SEBASTIÃO',
    designation: 'DOCENTE DO CURSO DE GESTÃO DE EMPRESA',
  },
  {
    id: 3,
    image: require('../../assets/Doc_03.jpg'),
    name: 'ADAO GENEROSO',
    designation: 'DOCENTE DO CURSO DE CONTABILIDADE',
  },
  {
    id: 4,
    image: require('../../assets/Doc_04.jpg'),
    name: 'ADELINO SEBASTIÃO',
    designation: 'DOCENTE DO CURSO DE RELACOES INTERNACIONAIS',
  },
  {
    id: 5,
    image: require('../../assets/Doc_05.jpg'),
    name: 'ADERITO FERREIRA',
    designation: 'DOCENTE DO CURSO DE ANALISES CLINICAS',
  },
  {
    id: 6,
    image: require('../../assets/Doc_06.jpg'),
    name: 'ADERITO KAPAKALA',
    designation: 'DIRECTOR PRA AREA CIENTIFICA DA UN. ORG. DE CIENCIAS ECONOMICAS JURICAS E HUMANAS',
  },
  {
    id: 7,
    image: require('../../assets/Doc_07.jpg'),
    name: 'MARIA CASIMIRO',
    designation: 'DOCENTE COM CARGO NA GESTÃO',
  },
  {
    id: 8,
    image: require('../../assets/Doc_09.jpg'),
    name: 'SARA PINTO',
    designation: 'DOCENTE DA AREA DE SAUDE',
  }
];

function AppTeams() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.2,
      }
    );

    observer.observe(el);

    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);

  return (
    <section
      id="teams"
      className={`block teams-block ${isVisible ? 'fadeInDown' : 'fadeOutUp'}`}
      ref={sectionRef}
      style={{
        opacity: 0,
        transform: 'translateY(-40px)',
        transition: 'opacity 0.8s, transform 0.8s',
        marginTop: '-50px',
      }}
    >
      <Container fluid className="py-5">
        <div className="mb-5" style={{ textAlign: 'left' }}>
          <h2 style={{ color: '#00761F',fontWeight: 700, fontSize: '2.5rem', textTransform: 'uppercase' }}>
            Corpo Docente
          </h2>
          <div
            className="subtitle"
            style={{
              fontSize: '1.25rem',
              color: '#444',
              fontWeight: 500,
              letterSpacing: '0.5px',
              textAlign: 'left'
            }}
          >
            Conheça nossos especialistas dedicados e apaixonados pelo ensino
          </div>
          <div
            style={{
              width: '80px',
              height: '4px',
              background: 'linear-gradient(90deg, #00761F 0%, #00b86b 100%)',
              marginLeft: 0,
              borderRadius: '2px'
            }}
          />
        </div>
        <Row className="justify-content-start">
          {teamsData.map((team, idx) => (
            <Col sm={6} md={4} lg={3} key={team.id} className="mb-5 d-flex">
              <div
                className="team-card shadow rounded-4 p-4 text-center bg-white h-100 w-100 team-card-hover custom-team-card"
                style={{
                  border: '1.5px solid #e6f4ea',
                  boxShadow: '0 6px 32px rgba(0, 118, 31, 0.10)',
                  transition: 'transform 0.4s, box-shadow 0.3s',
                  animation: `fadeUp 0.7s ${0.2 + idx * 0.1}s forwards`
                }}
              >
                <div className="team-image mb-3" style={{ position: 'relative' }}>
                  <div
                    style={{
                      background: 'linear-gradient(135deg, #e6f4ea 0%, #f8fafc 100%)',
                      borderRadius: '50%',
                      padding: '8px',
                      display: 'inline-block',
                      boxShadow: '0 2px 12px rgba(0, 118, 31, 0.07)'
                    }}
                  >
                    <Image
                      src={team.image}
                      roundedCircle
                      fluid
                      style={{
                        width: '120px',
                        height: '120px',
                        objectFit: 'cover',
                        border: '4px solid #00761F'
                      }}
                      alt={team.name}
                      className="custom-team-image"
                    />
                  </div>
                  <span
                    style={{
                      position: 'absolute',
                      bottom: '-14px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      background: '#fff',
                      color: '#00b86b',
                      fontWeight: 700,
                      fontSize: '0.9rem',
                      padding: '3px 16px',
                      borderRadius: '14px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.07)'
                    }}
                  >
                    {team.designation.split(' ')[0]}
                  </span>
                </div>
                <div className="team-content mt-4">
                  <h5
                    className="mb-1"
                    style={{
                      fontWeight: 700,
                      color: '#00761F',
                      fontSize: '1.18rem',
                      letterSpacing: '0.5px',
                      textTransform: 'capitalize'
                    }}
                  >
                    {team.name}
                  </h5>
                  <span
                    className="designation d-block mb-2"
                    style={{
                      fontSize: '1rem',
                      color: '#555',
                      fontStyle: 'italic',
                      letterSpacing: '0.2px'
                    }}
                  >
                    {team.designation}
                  </span>
                  <div style={{ marginTop: '10px' }}>
                    <span
                      style={{
                        display: 'inline-block',
                        background: 'linear-gradient(90deg, #e6f4ea 0%, #c6f7e2 100%)',
                        color: '#00761F',
                        fontSize: '0.9rem',
                        padding: '4px 14px',
                        borderRadius: '10px',
                        fontWeight: 600
                      }}
                    >
                      Especialista
                    </span>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      <style>
        {`
          @keyframes fadeUp {
            to {
              opacity: 1;
              transform: none;
            }
          }
          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-40px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          @keyframes slideUp {
            from {
              opacity: 1;
              transform: translateY(0);
            }
            to {
              opacity: 0;
              transform: translateY(-40px);
            }
          }

          .fadeInDown {
            animation: slideDown 0.8s forwards;
          }

          .fadeOutUp {
            animation: slideUp 0.8s forwards;
          }

          .team-card:hover {
            transform: translateY(-8px) scale(1.03);
            box-shadow: 0 10px 36px rgba(0, 118, 31, 0.14);
          }

          .custom-team-image {
            box-shadow: 0 2px 16px rgba(0, 118, 31, 0.10);
          }
        `}
      </style>
    </section>
  );
}

export default AppTeams;
